export default __webpack_public_path__ + "static/media/welcome_screen.5a765401.jpg";